// extracted by mini-css-extract-plugin
module.exports =  {"body":"ZHitwlXnUtAKidpE5beT"};